import { render, staticRenderFns } from "./lastUpdate-list.vue?vue&type=template&id=769910bf&scoped=true&"
import script from "./lastUpdate-list.vue?vue&type=script&lang=js&"
export * from "./lastUpdate-list.vue?vue&type=script&lang=js&"
import style0 from "./lastUpdate-list.vue?vue&type=style&index=0&id=769910bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769910bf",
  null
  
)

export default component.exports